import React, { useState, useContext, useEffect } from 'react'
import FieldsView from '@/product/components/organisms/Customized/User/FieldsView'
import { dateTimeFormatFunction } from '@/product/common/components'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import AddBuyer from '@/custom/components/organisms/User/Role/AddBuyer'
import * as Yup from 'yup'

const UserCommon = (props) => {
    const dynamicContext = useContext(DynamicContext)

    const { user_dynamicfields } = dynamicContext

    const [updatedValues, setUpdatedValues] = useState({})

    const [fieldValue, setFieldValue] = useState([])

    const customInitial = {
        id: 0,
        admin: 0,
    }

    useEffect(() => {
        if (user_dynamicfields && user_dynamicfields.length) {
            console.log(user_dynamicfields, 'userr')
            let dynamicValueAssign = []
            user_dynamicfields.map((item) => {
                item.view_on
                    ? item.view_on.includes('3')
                        ? dynamicValueAssign.push(item)
                        : {}
                    : dynamicValueAssign.push(item)
            })
            dynamicValueAssign.push({
                name: 'market_status',
                value: 'draft',
                type: 'default',
                active: 1,
            })
            const temp = dynamicValueAssign.filter((item) => {
                return (
                    item.name != 'password' &&
                    item.name != 'confirm_password' &&
                    item.name != 'job_title' &&
                    item.name != 'how_they_learned_about_us' &&
                    item.name != 'fill_others' &&
                    item.for_buyer === 1
                )
            })
            setFieldValue(temp)
        }
    }, [user_dynamicfields])

    const additionalFieldUpdate = (data) => {
        setUpdatedValues(data)
    }
    return (
        <>
            <AddBuyer
                data={props.data}
                // populateValidation={true}
                fieldValue={fieldValue}
                function={props.function}
                customInitial={customInitial}
                additionalFormikUpdate={additionalFieldUpdate}
            />
        </>
    )
}

export default UserCommon
